import React from 'react';
import { FormBuilder } from 'commons-ui';
import { FORM_LAYOUT_CONFIG, FORM_FIELD_CONFIG, editValidationSchema } from '../../utils/formConfig';
import useEdit from './useEdit';

const EditExperiment: React.FC<{}> = () => {
	const { data, showLoader, handleFormSubmit, handleFormCancel, setShowLoader } = useEdit();

	return (
		<FormBuilder
			data={data}
			mode='edit'
			showLoader={showLoader}
			handleFormSubmit={handleFormSubmit}
			handleFormCancel={handleFormCancel}
			validationSchema={editValidationSchema}
			setShowLoader={setShowLoader}
			fieldConfig={FORM_FIELD_CONFIG}
			layoutConfig={FORM_LAYOUT_CONFIG}
		/>
	);
};

export default EditExperiment;
